import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import Listing from '../../../modules/withdrawal/components/coordinator/Listing';

const ListingPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader title={t('withdrawal->>Coordinator.Listing.TitleHeader')} />
      <Listing />
    </>
  );
};

export default ListingPage;
